import React, { useMemo } from 'react'
import useRedtailMetricPreset from '../../ComponentBlueprint/renderers/redtailMetric/useRedtailMetricPreset'
import useRedtailListPreset from '../../ComponentBlueprint/renderers/redtailList/useRedtailListPreset'
import { useDailyGreetingShared } from './useDailyGreetingShared'
import { resolveTasksMetricConfig } from './resolveTasksMetricConfig'
import { buildSubtitle } from './buildSubtitle'
import DailyGreetingShell from './DailyGreetingShell'
import { dailyGreetingRedtailWithBlueprintMeetingsPropTypes } from './dailyGreetingPropTypes'

function DailyGreetingRedtailWithBlueprintMeetings ({
  userName,
  meetingsLinkTo: _meetingsLinkTo,
  tasksLinkTo: _tasksLinkTo,
  overdueStartDate,
  tasksLinkMode: _tasksLinkMode,
  blueprintCode,
  meetingsPresentationKey: _meetingsPresentationKey,
  tasksPresentationKey,
  blueprint,
  isLoadingBlueprint,
  meetingsSlot
}) {
  const shared = useDailyGreetingShared({
    userName,
    rawOverdueStartDate: overdueStartDate,
    skipWealthJourneyMeetings: true
  })
  const {
    classes,
    tasksDueTodayCount,
    isLoadingDueToday,
    greetingText
  } = shared

  const meetingsListConfig = useMemo(() => {
    if (!meetingsSlot) return {}
    return meetingsSlot.config ?? {}
  }, [meetingsSlot])

  const {
    items,
    isLoading: isLoadingRedtailMeetingsList
  } = useRedtailListPreset('upcoming-meetings', meetingsListConfig)

  const metricConfig = useMemo(
    () =>
      resolveTasksMetricConfig({
        blueprintCode,
        tasksPresentationKey,
        blueprint,
        isLoadingBlueprint
      }),
    [blueprintCode, tasksPresentationKey, blueprint, isLoadingBlueprint]
  )

  const isBlueprintPendingForMetric = Boolean(
    blueprintCode && tasksPresentationKey && isLoadingBlueprint
  )

  const { value, isLoading: isLoadingOverdueRaw, notLinked } = useRedtailMetricPreset(
    'past-due-tasks',
    metricConfig
  )

  const isLoadingOverdue = isLoadingOverdueRaw || isBlueprintPendingForMetric
  const overdueCountForSubtitle = isBlueprintPendingForMetric ? 0 : (value != null ? value : 0)
  const includeOverduePhrase = !notLinked

  const isLoadingMeetingsEffective =
    isLoadingBlueprint || isLoadingRedtailMeetingsList
  const meetingsRemainingCountEffective = isLoadingBlueprint ? 0 : items.length

  const subtitleNode = useMemo(
    () =>
      buildSubtitle({
        classes,
        meetingsRemainingCount: meetingsRemainingCountEffective,
        isLoadingMeetings: isLoadingMeetingsEffective,
        tasksDueTodayCount,
        isLoadingDueToday,
        overdueCount: overdueCountForSubtitle,
        isLoadingOverdue,
        includeOverdue: includeOverduePhrase,
        meetingsCopyVariant: 'upcoming',
        allCaughtUpCopyVariant: 'redtailNoUpcomingOrPastDue'
      }),
    [
      classes,
      meetingsRemainingCountEffective,
      isLoadingMeetingsEffective,
      tasksDueTodayCount,
      isLoadingDueToday,
      overdueCountForSubtitle,
      isLoadingOverdue,
      includeOverduePhrase
    ]
  )

  return (
    <DailyGreetingShell
      classes={classes}
      greetingText={greetingText}
      subtitleNode={subtitleNode}
    />
  )
}

DailyGreetingRedtailWithBlueprintMeetings.propTypes = dailyGreetingRedtailWithBlueprintMeetingsPropTypes

export default DailyGreetingRedtailWithBlueprintMeetings
